


























import Vue, { PropType } from 'vue';
import { Cv, CvSectionGallery, CvSectionGalleryItem } from '@/../gen';
// @ts-ignore
import GalleryItemPreviewComponent from '@/containers/cv-section-gallery-item/preview.vue';

export default Vue.extend({
  components: {
    // TODO rename
    GalleryItemPreviewComponent,
  },
  props: {
    cv: {
      type: Object as PropType<Cv>,
      required: true,
    },
    section: {
      type: Object as PropType<CvSectionGallery>,
      required: true,
    },
    sectionItems: {
      type: Array as PropType<CvSectionGalleryItem[]>,
      required: true,
    },
  },
  methods: {
    parseDescription(description: string | null) {
      return description ? `${description}`.replace(/\s+/g, '') : null;
    },
  },
});
